import * as d3 from "d3";
import * as utils from "../utils/utils.js";

d3.selection.prototype.moveToBack = function() {  
    return this.each(function() { 
        var firstChild = this.parentNode.firstChild; 
        if (firstChild) { 
            this.parentNode.insertBefore(this, firstChild); 
        } 
    });
};

export function render(data){
   

    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "columnplot" && d.column == 3)
        .each(function(d){
            let plot = d3.select(`#${d.parentId}-columnplot`);
            plot.selectAll(".error-message").remove();

                let color = d3.scaleLinear().domain(d.scale.y.domain()).range(["rgba(239, 0, 68, 1)", "rgba(239, 0, 68, 1)"])
                let bars = plot.selectAll(`.columnplot-bar`)
                    .data(data.filter(e=> e._info.cl == d._userInput.key))
                bars
                    .exit().remove();
                bars
                    .enter()
                    .append("rect")
                    .merge(bars)
                    .attr("x", e=> d.scale.x(e.x) + 0.2)
                    .attr("y", e=> d.scale.y(e.y))
                    .attr("height", e=>  d.innerHeight - d.scale.y(e.y))
                    .attr("width", d.scale.x.bandwidth()-0.4)
                    .attr("class", `columnplot-bar`)
                    .attr("fill", e=> color(e.y))

                    if (data.length == 0){
                   //     plot.selectAll(".axis-y").remove();
                        plot.append("text")
                            .html("No data")
                            .attr("x", d.padding.left)
                            .attr("y", d.innerHeight/2)
                            .attr("class", "error-message")
                    }
        
        })
}

export function clear(){
    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "columnplot" && d.column == 3)
        .each(function(d){
            let plot = d3.select(`#${d.parentId}-columnplot`);
              //  plot.selectAll(".axis-y").remove();
                plot.selectAll(".error-message").remove();
                plot.selectAll(`.columnplot-bar`).remove();
        })
}

export function axis(){
    d3.selectAll(".ljs--lattice-plot")
    .filter(d=> d.type == "columnplot" && d.column == 3)
    .each(function(d){

        let plot =  d3.select(`#${d.parentId}-columnplot`)
        d.scale = {
            x: d3.scaleBand().domain(["NS", "g", "b", "a"]).range([0, d.innerWidth]),
            y: d3.scaleLinear().domain([0, 14]).range([d.innerHeight, 0])
        }
        var x = d3.axisBottom()
            .scale(d.scale.x)
            .tickSizeInner(d.innerHeight);   

        var y = d3.axisLeft()
            .scale(d.scale.y)
            .tickValues([0, d.scale.y.domain()[1]])
            .tickSizeInner(-d.innerWidth)

         plot.append("g").attr("class", "axis axis-x")
                .attr("transform", `translate(0,0)`)
                .call(x )
                .selectAll("text")
                .attr("text-anchor", "middle")
                .html(e=>utils.dict().conditionRnaSeq[e])

          plot.append("g").attr("class", "axis axis-y")
            .attr("transform", `translate(0,0)`)
            .call(y)
            .selectAll("text")
            .attr("dy", (e)=>{
                if (e==0){ return 0 }
                else { return utils.dy.tick }
            })

            if (d.row==0){
                plot.append("text").html("Normalized log2 (RPM)")
                    .attr("class", "sm-axis-title")
                    .attr("transform", `rotate(-90)`)
                    .attr("x", -d.innerHeight/2)
                    .attr("y", -d.padding.left*.8)
                    .attr("text-anchor", "middle")
    
                plot.append("text").html("Condition")
                    .attr("class", "sm-axis-title")
                    .attr("x", d.innerWidth/2)
                    .attr("y", d.innerHeight + (d.padding.bottom/1.5))
                    .attr("text-anchor", "middle")
            }

     
    })
}